<div class="form-parent">
       <kgrid [apiName]="apiName"
       [label]="label"
       [areaName]="areaName"
       [name]="apiName"
       reportName="PeopleInfoList"
       pathPreFix="GNR"
       [inputEditorform]="inputEditorform"
       [actions]="actions"
       [actionTregger]="onActionClick.bind(this)"
       [unSortableFilterable]="unSortableFilterable"
       defaultSortKey="'Code'">
</kgrid>
</div>
